// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { Box, Container as MuiContainer, styled, Typography } from '@mui/material';

import Steps from './Steps';

const Wrapper = styled(Box)({
  marginTop: 200,
  marginBottom: 100
});

const Container = styled(MuiContainer)({});

function Counting() {
  return (
    <Wrapper>
      <Typography marginBottom={6} textAlign="center" variant="h1">
        How to participate
      </Typography>
      <Container>
        <Steps current={3} />
      </Container>
    </Wrapper>
  );
}

export default Counting;
